<sb-data-table [tableData]="versions"
            [tableColumns]="tableColumns"
            [isLoadingData]="isLoading"
            [isRowClickable]="false"
            [isClickDisabled]="true"
            ></sb-data-table>
